<template>
  <div :class="d._class" :id="d.title">
    <div class="container">
      <h3>{{d.title}}</h3>
      <p class="paragraph" v-for="(x, i) of d.paragraphs" :key="i">{{x}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "BasicSection",
  props: {
    // d:
    //  _class, ="team"
    //  title,
    //  paragraphs,
    d: {
      type: Object,
      default: function() {
        return {
          _class: "team",
          title: "",
          paragraphs: [],
        };
      }
    }
  }
};
</script>

<style scoped>
p {
  font-size: 1.5em;
  margin-top: 5%;
}
</style>


// WEBPACK FOOTER //
// src/components/BasicSection.vue